import { render, staticRenderFns } from "./ShipmentReminderList.vue?vue&type=template&id=67f8d630"
import script from "./ShipmentReminderList.vue?vue&type=script&lang=js"
export * from "./ShipmentReminderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports